import { enUS, tr } from 'date-fns/locale';
import type { Locale } from 'date-fns';

/** Sayfa / API dil kodunu date-fns takvim locale'ine çevirir. */
export function getDateFnsLocale(language?: string): Locale {
    const code = (language ?? 'en').split('-')[0]?.toLowerCase() ?? 'en';
    if (code === 'tr') {
        return tr;
    }
    return enUS;
}
